<template>
    <v-card class="pa-0">
        <v-toolbar
        style="background-color: rgba(0, 0, 0, 0)"
        flat
        extension-height="56">
            <v-btn class="pt-0" icon @click="$emit('close')"><v-icon v-text="mode == 'new' ? 'close' : 'arrow_back'"></v-icon></v-btn>
            <v-text-field
              v-model="name"
              single-line
              :counter="Boolean(name && name.length > 30)"
              maxlength="40"
              label="Name"
              class="pt-4"/>
            <v-select class="pt-4 ml-2" style="max-width: 80px;" v-model="color" :items="colors">
                <template v-slot:item="{item}">
                    <v-btn icon><v-icon :color="item">fiber_manual_record</v-icon></v-btn>
                    {{ item }}
                </template>
                <template v-slot:selection="{item}">
                    <v-btn icon small><v-icon :color="item">fiber_manual_record</v-icon></v-btn>
                </template>
            </v-select>
        <v-btn text class="pl-5" v-if="mode == 'new'" @click="post_item" :disabled="!valid">Create</v-btn>
        <v-btn text class="pl-5" v-if="mode == 'modify'" @click="put_item" :disabled="!valid">Modify</v-btn>
    </v-toolbar>
    <v-card-actions v-if="mode == 'modify'">
        <v-row justify="center" class="pa-0 ma-0">
            <v-btn text color="error" @click="delete_item">Delete</v-btn>
        </v-row>
    </v-card-actions>
    </v-card>
</template>

<script>

export default {
    name: 'AssignmentTopic',
    props: {
        assignment: Object,
        mode: String
    },
    data () {
        return {
            name: null,
            color: null,
            colors: [
                'red',
                'pink',
                'purple',
                'deep-purple',
                'indigo',
                'blue',
                'light-blue',
                'cyan',
                'teal',
                'green',
                'light-green',
                'lime',
                'yellow',
                'amber',
                'orange',
                'deep-orange',
                'brown',
                'blue-grey'
            ],
        }
    },
    watch: {
        mode (newVal, oldVal) { // eslint-disable-line no-unused-vars
            if (newVal == 'new') {
                this.color = null;
                this.name = null;
            }
        },
        assignment: {
            handler (newVal, oldVal) { // eslint-disable-line no-unused-vars
                if (newVal == 'modify') {
                    this.color = newVal.color;
                    this.name = newVal.name;
                }
            },
            deep: true
        }
    },
    computed: {
        valid () {
            return this.name && this.name.length && this.color;
        }
    },
    methods: {
        async post_item () {
            await this.$store.dispatch(
                'teacher/post_assignment_topic',
                {name: this.name, color: this.color}
            );
            this.$emit('close');
        },
        async put_item () {
            await this.$store.dispatch(
                'teacher/put_assignment_topic',
                {name: this.name, color: this.color, id: this.assignment.id}
            );
            this.$emit('close');
        },
        async delete_item () {
            await this.$store.dispatch(
                'teacher/delete_assignment_topic',
                {id: this.assignment.id}
            );
            this.$emit('close');
        },
    },
    mounted () {
        if (this.mode == 'modify') {
            this.name = this.assignment.name;
            this.color = this.assignment.color;
        }
    }
}
</script>
